import React, { useState } from "react";
import Spinner from "react-bootstrap/Spinner";
import Carousel from "react-multi-carousel";
import { Link } from "react-router-dom";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import { TRANSITION_DURATION } from "../PlaylistConstants";
import ScreenCard from "../../../../../app/src/Components/common/ScreenCard/ScreenCard";
import "react-multi-carousel/lib/styles.css";
import "@detail/Pages/DetailPage/CarrouselStyle.css";
import { evaluateItemClass, LIMIT_ITEMS } from "./utils";
import {
    actionTypeContainer,
    generateSlug,
} from "../../../../../app/src/Utils/utils";
import { isCordovaAvailable } from "../../../../../app/src/Utils/secureStorageUtil";
import { responsiveList } from "../CarrouselStyle";
import MobileScrollCarousel from "./MobileScrollCarousel";
import useIsMobileViewport from "./useIsMobileViewport";
import useSuppressClickOnDrag from "./useSuppressClickOnDrag";


const ListScreenComponent = ({
  key,
  className,
  style,
  title,
  hasMoreContents,
  id,
  typeBanner,
  playlist,
  playSpinner,
  trigger,
  titleColor,
  turnOnLoading,
  contentId = null,
  showItemTitles = true
}) => {
  const [overOnCard, setOverOnCard] = useState(false);
  const {t} = useTranslation()
  const isMobile = isCordovaAvailable();
  const isMobileViewport = useIsMobileViewport();
  const dragSuppressHandlers = useSuppressClickOnDrag();

  const minimumItems = +playlist?.length < LIMIT_ITEMS ? " BlockCarousel" : " ";

    return (
        <div className="PlaylistContainer CarouselContainer GroupWidget"  key={key}>
            <div className={"Playlist " + className} style={style}>
                <div className="Titulo ListScreenTitle">
                    <p style={{color: titleColor}}>{title}</p>
                    {hasMoreContents &&
                        <Link to={`${actionTypeContainer(trigger).ROUTE}/${generateSlug(title)}/${id}`}
                              className="Titulo button-link-secondary ListScreenShowMore">
                            <div className="ShowMoreText">{t('ficha.showmore')}</div>
                            <FontAwesomeIcon icon={faChevronRight} className="ListScreenShowMoreIcon"/>
                        </Link>}
                </div>
                { playlist?.length > 0 && isMobileViewport &&
                    <MobileScrollCarousel
                        itemWidth="calc(50vw - 12px)"
                        itemMaxWidth="120px"
                        containerClassName={
                            "carousel-container PlaylistCollection " +
                            typeBanner +
                            " " +
                            minimumItems
                          }
                    >
                        {playlist?.map((w, i) => {
                            return <div className={evaluateItemClass({
                                i,
                                overOnCard,
                                playlist,
                                itemClass: "PlaylistItemContainer",
                              })}
                                 key={i} onMouseEnter={()=> setOverOnCard(i)}
                                 onMouseLeave={()=> setOverOnCard(false)}
                                 onPointerDownCapture={dragSuppressHandlers.onPointerDownCapture}
                                 onClickCapture={dragSuppressHandlers.onClickCapture}
                                 onDragStartCapture={dragSuppressHandlers.onDragStartCapture}
                            >
                                <ScreenCard
                                    item={w}
                                    trigger={trigger}
                                    contentId={contentId}
                                    turnOnLoading={turnOnLoading}
                                    showTitle={showItemTitles}
                                />
                            </div>}
                        )}
                    </MobileScrollCarousel>}

                { playlist?.length > 0 && !isMobileViewport &&
                    <Carousel
                        swipeable={true}
                        draggable
                        showDots={false}
                        responsive={responsiveList}
                        infinite={false}
                        autoPlay={false}
                        keyBoardControl={false}
                        transitionDuration={TRANSITION_DURATION}
                        customTransition={isMobile ? "transform 300ms ease-in-out 0s" : "transform 1000ms ease-in-out 0s"}
                        centerMode={false}
                        containerClass={
                            "carousel-container PlaylistCollection " +
                            typeBanner +
                            " " +
                            minimumItems
                          }
                        dotListClass="custom-dot-list-style"
                        itemClass="carousel-item-padding-40-px CardContainer"
                    >
                        {playlist?.map((w, i) => {
                            return <div className={evaluateItemClass({
                                i,
                                overOnCard,
                                playlist,
                                itemClass: "PlaylistItemContainer",
                              })}
                                 key={i} onMouseEnter={()=> setOverOnCard(i)}
                                 onMouseLeave={()=> setOverOnCard(false)}
                                 onPointerDownCapture={dragSuppressHandlers.onPointerDownCapture}
                                 onClickCapture={dragSuppressHandlers.onClickCapture}
                                 onDragStartCapture={dragSuppressHandlers.onDragStartCapture}
                            >
                                <ScreenCard
                                    item={w}
                                    trigger={trigger}
                                    contentId={contentId}
                                    turnOnLoading={turnOnLoading}
                                    showTitle={showItemTitles}
                                />
                            </div>}
                        )}
                    </Carousel>}
            </div>
            {
                playSpinner && <div className="SpinnerContainer">
                    <Spinner animation="border" variant="primary" />
                </div>
            }
        </div>
    )
};

export default ListScreenComponent;
